import S from '@/settings'
const ERRORS = {
  UNKNOWN_ERROR: 'Error desconocido',
  SESSION_NOT_FOUND: 'No se encontró la sesión',
  SIGNUP: {
    INVALID_EMAIL: 'Formato de correo electrónico inválido',
    INVALID_FULL_NAME: 'Nombre completo inválido',
    INVALID_PASSWORD: 'Contraseña inválida: La contraseña debe tener entre 6 y 255 caracteres',
    INVALID_USERNAME:
      'Nombre de usuario inválido: El nombre de usuario debe tener entre 4 y 31 caracteres, ' +
      'y solo puede contener letras minúsculas, números del 0-9, -, y _',
  },
  DOCUMENT: {
    UPLOAD_FILE: 'Error al subir el contenido del documento',
    UPDATE: 'Error al actualizar documento',
    PREVIEW_DELETE: 'Error al previsualizar la eliminación del documento',
    DELETE: 'Error al eliminar documento',
    REAL_WORK_REQUIRED: 'Confirmación requerida: este documento contiene datos modificados por usuarios',
  },
  LOGIN: {
    INVALID_CREDENTIALS: 'Credenciales inválidas',
    TOKEN_EXPIRED: 'Este enlace de inicio de sesión ha expirado. Por favor, solicita uno nuevo.',
    TOKEN_ALREADY_USED: 'Este enlace de inicio de sesión ya ha sido utilizado. Por favor, solicita uno nuevo.',
    ACCESS_REVOKED: 'Esta cuenta ya no tiene acceso. Ponte en contacto con tu administrador.',
  },
  FILE_SIZE_LIMIT_EXCEEDED:
    `Tamaño de archivo excedido. Por favor suba un archivo con tamaño menor a` + ` ${S.FILE_SIZE_LIMIT_IN_MB} MB`,
  FILE_UPLOAD: {
    NO_EXTENSION: 'El archivo debe tener extensión',
    TYPE_NOT_ALLOWED: 'Tipo de archivo no permitido',
    CONTENT_NOT_VERIFIED: 'No se pudo verificar el contenido del archivo',
    CONTENT_MISMATCH: 'El contenido del archivo no coincide con la extensión',
    ONLY_ALLOWED_QUESTIONNAIRE_TYPES: 'Solo se permiten archivos Excel, Word, PDF u OpenDocument',
    MUST_BE_VALID_QUESTIONNAIRE_TYPE: 'El contenido del archivo no corresponde a un formato de cuestionario permitido',
    ONLY_CSV: 'Solo se permiten archivos .csv',
    ONLY_PDF_OR_MD: 'Solo se permiten archivos PDF o Markdown (.md)',
    FILE_TOO_LARGE: 'Archivo demasiado grande',
  },
  FETCH_CONTROL: 'No se puede cargar el control',
  FETCH_DOCUMENT: 'No se puede cargar el documento',
  FETCH_EVIDENCE: 'No se puede cargar la evidencia',
  FETCH_TASK: 'No se pudo cargar la task',
  FETCH_EMPLOYEE: 'No se puede cargar el empleado',
  AUTOMATIC_PENTESTING: 'Error al obtener datos de pentesting automatizado',
  MONITORING: 'Error al obtener datos de monitoreo',
  PASSWORD_MANAGER: 'Error al obtener datos del gestor de contraseñas',
  MDM: 'Error al obtener datos de registro MDM',
  TRAINING: 'Error al obtener datos de entrenamiento',
  CODE_SCANNER: 'Error al obtener datos del escáner de código',
  PHISHING_EXERCISES: 'Error al obtener datos de ejercicios de phishing',
  INFRASTRUCTURE: 'Error al obtener datos de infraestructura',
  IDENTITIES: 'Error al obtener datos de identidades',
  CONTROLS: {
    LIST: 'Error al obtener controles',
    UPDATE: 'Error al actualizar control',
    GET_DOC_EVIDENCE: 'Error al obtener documentos y evidencias por id de control',
    GET: 'Error al obtener control',
    PREVIEW_DELETE: 'Error al previsualizar la eliminación del control',
  },
  EVIDENCES: {
    FETCH: 'Error al obtener evidencia',
    CREATE: 'Error al crear evidencia',
    UPDATE: 'Error al actualizar evidencia',
    LIST: 'Error al obtener evidencias',
    SIZE_LIMIT:
      `Tamaño de archivo excedido. Por favor suba un archivo con tamaño menor a` + ` ${S.FILE_SIZE_LIMIT_IN_MB} MB`,
    BULK_EDIT_OWNER: 'Error al actualizar el propietario de las evidencias',
    UPLOAD_FILE: 'Error al subir el contenido de la evidencia',
    PREVIEW_DELETE: 'Error al previsualizar la eliminación de la evidencia',
    DELETE: 'Error al eliminar evidencia',
    REAL_WORK_REQUIRED: 'Confirmación requerida: esta evidencia contiene datos modificados por usuarios',
  },
  TASKS: {
    LIST: 'Error al obtener tareas',
    CREATE: 'Error al crear tarea',
    GET: 'Error al obtener tarea',
    UPDATE: 'Error al actualizar tarea',
    CREATE_BULK: 'Error al crear tareas',
    DELETE: 'Error al eliminar tarea',
  },
  BULK_EDIT: {
    OWNER: 'Error al actualizar propietario',
    STATUS: 'Error al actualizar estado',
  },
  NON_CONFORMITIES: {
    LIST: 'Error al obtener no conformidades',
    GET: 'Error al obtener no conformidad',
    CREATE: 'Error al crear no conformidad',
    UPDATE: 'Error al actualizar no conformidad',
    DELETE: 'Error al eliminar no conformidad',
    NOT_FOUND: 'No se encontró la no conformidad',
  },
  OPEN_SEARCH_AUTH: {
    FRONT: 'Error de autenticación del panel',
    SECRET_NOT_DEFINED: 'OPENSEARCH_SECRET no está definido',
    INVALID_CAPABILITY: (capability: string) => `Capacidad inválida: ${capability}`,
  },
  RISK: {
    FETCH: 'Error al obtener el riesgo',
    UPDATE: 'Error al actualizar el riesgo',
    UNKNOWN_CATALOGUE_SCENARIO: 'Escenario del catálogo desconocido',
  },
  USERS: {
    LIST: 'Error al obtener usuarios',
    CREATE: 'Error al crear usuario',
    DELETE: 'Error al eliminar usuario',
    UPDATE_ROLE: 'Error al actualizar el rol del usuario',
    INVALID_ROLE: 'Este rol no se puede asignar',
    ROLE_LOCKED: 'Contacta con soporte para cambiar el rol de este usuario',
    SERVICE_ACCOUNT_EMAIL: 'Este email pertenece a una cuenta de servicio',
  },
  SERVICE_ACCOUNTS: {
    MARK: 'Error al marcar el empleado como cuenta de servicio',
    IN_USE: 'Este empleado sigue referenciado en otros datos y no se puede marcar como cuenta de servicio',
    CANNOT_MARK_SELF: 'No puedes marcarte a ti mismo como cuenta de servicio',
    LIST: 'Error al obtener las cuentas de servicio',
    RESTORE: 'Error al devolver la cuenta de servicio a los empleados',
    EMAIL_TAKEN: 'Ya existe un empleado con este email',
  },
  API_KEYS: {
    NO_ACCESS: 'Tu organización no tiene acceso a la API pública',
    INVALID_NAME: 'El nombre de la API key debe tener entre 1 y 100 caracteres',
    NOT_FOUND: 'API key no encontrada',
    CREATE: 'Error al crear la API key',
    LIMIT_REACHED: 'Ya tienes 10 API keys activas. Revoca una para crear otra',
    LIST: 'Error al obtener las API keys',
    REVOKE: 'Error al revocar la API key',
  },
  PUBLIC_API_ENDPOINTS: {
    LIST: 'Error al obtener la configuración de los endpoints de la API pública',
    UPDATE: 'Error al actualizar la configuración del endpoint de la API pública',
    NOT_FOUND: 'Endpoint de la API pública no encontrado',
  },
  EMPLOYEES: {
    UPDATE: 'Error al actualizar empleado',
    CREATE_ONBOARDING_TASKS: 'Error al generar tareas de onboarding',
    CREATE_OFFBOARDING_TASKS: 'Error al generar tareas de offboarding',
    ADD_CHECKLIST_ITEM: 'Error al añadir el elemento de la lista',
    UPDATE_CHECKLIST_ITEM: 'Error al actualizar el elemento de la lista',
    REMOVE_CHECKLIST_ITEM: 'Error al eliminar el elemento de la lista',
    REORDER_CHECKLIST: 'Error al reordenar la lista',
    RESET_CHECKLIST: 'Error al restablecer la lista',
    FETCH_TASK_EVIDENCE: 'No se pudo cargar la evidencia de la tarea',
    UPDATE_TASK_EVIDENCE: 'No se pudo actualizar la evidencia de la tarea',
    UPLOAD_TASK_EVIDENCE_FILE: 'No se pudo subir el archivo de evidencia',
    REMOVE_TASK_EVIDENCE_FILE: 'No se pudo eliminar el archivo de evidencia',
  },
  INVALID_FILE_TYPE: 'Tipo de archivo no permitido',
  FILE_TOO_LARGE: 'Archivo demasiado grande',
  USER_EMAIL_ALREADY_EXISTS: 'El correo electrónico ya existe',
  USER_EMAIL_INVALID: 'El correo electrónico es inválido',
  USER_ROLE_REQUIRED: 'Hay que seleccionar un rol',
  HARDENING: {
    LIST: 'Error al obtener dispositivos de hardening',
    GET: 'Error al obtener dispositivo de hardening',
    NOT_LOADED: 'Error al cargar el dispositivo de hardening',
  },
  APPSEC: {
    GET: 'Error al obtener dashboard',
    MUTE: 'Error al silenciar el finding',
    UNMUTE: 'Error al reactivar el finding',
  },
  CSPM: {
    GET: 'Error al obtener los datos del dashboard',
    GET_FINDINGS: 'Error al obtener los findings',
    GET_FINDING_DETAIL: 'Error al obtener el detalle del finding',
    EMPTY_DASHBOARD: 'No se encontraron datos del dashboard',
    MUTE: 'Error al silenciar el finding',
    UNMUTE: 'Error al reactivar el finding',
  },
  EASM: {
    MUTE: 'Error al silenciar el finding',
    UNMUTE: 'Error al reactivar el finding',
    REVIEW_BREACH: 'Error al marcar la brecha como revisada',
  },
  INFRASTRUCTURE_VULNERABILITIES: {
    MUTE: 'Error al silenciar la vulnerabilidad',
    UNMUTE: 'Error al reactivar la vulnerabilidad',
  },
  HOME: 'Error al obtener los datos del dashboard de inicio',
  EXECUTIVE_REPORT: 'Error al solicitar el informe ejecutivo',
}
export default ERRORS
